import type CSS from 'csstype';

import { extractCssStyle } from '../../utilities';

export interface DimensionStylingProps {
  width?: string;
  height?: string;

  maxWidth?: string;
  maxHeight?: string;

  minWidth?: string;
  minHeight?: string;

  flex?: CSS.Property.Flex;
}

export const DimensionStyling = (props: DimensionStylingProps) => extractCssStyle(props);
